module.exports = __webpack_public_path__ + "static/zebra-0f7efaae9fa3f642639a697fa1a4db4f.jpeg";